import { ButtonSecondary, cssColorValue, screenMdMin, semanticColors, spacer8 } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from 'providers/translations/TranslationProvider';
import { HeaderSchema, LanguageSelectionSchema, MastheadLink } from 'types/navigation';

import { NavBarLanguageItem } from './Language';

const LinksWrapper = styled.section`
  & ul {
    align-items: center;
    display: flex;
    gap: ${spacer8};
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @media (max-width: ${screenMdMin}) {
    display: none;
  }
`;

const OutlineButton = styled(ButtonSecondary)`
  background: transparent;
  border: 1px solid ${cssColorValue(semanticColors.textBase)};
  color: ${cssColorValue(semanticColors.textBase)};

  &:hover {
    background: transparent;
  }
`;

const InvertedButton = styled(ButtonSecondary)`
  background-color: ${cssColorValue(semanticColors.textBase)};
  border: 1px solid ${cssColorValue(semanticColors.textBase)};
  color: ${cssColorValue(semanticColors.backgroundBase)};
  cursor: pointer;

  &:hover {
    border: 1px solid ${cssColorValue(semanticColors.textBase)};
  }
`;

type Props = {
  headerEntry: HeaderSchema;
  languageSelectionEntry: LanguageSelectionSchema;
};

export const NavBarSecondaryLinks = ({ headerEntry, languageSelectionEntry }: Props) => {
  const { t } = useTranslation();
  const renderSecondaryLinkItem = (item: MastheadLink) => {
    if (item.variant === 'primaryButton') {
      return (
        <InvertedButton size="small" key={item.title} href={item.href} target={item.target}>
          {t(item.title)}
        </InvertedButton>
      );
    }

    if (item.variant === 'secondaryButton') {
      return (
        <OutlineButton size="small" key={item.title} href={item.href} target={item.target}>
          {t(item.title)}
        </OutlineButton>
      );
    }

    return null;
  };

  return (
    <LinksWrapper>
      <ul>
        <li>
          <NavBarLanguageItem container="header" languageSelectionEntry={languageSelectionEntry} />
        </li>
        {headerEntry.secondaryNav.map(renderSecondaryLinkItem)}
      </ul>
    </LinksWrapper>
  );
};
